import React, { useEffect, useState } from "react";
import "./AddAdvertisementTopic.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  categoryOptions,
  spinContent,
  topicTypeOptions,
} from "../../../services/customData";
import { Button, Modal, Spin, Form, message, Popover, Tabs } from "antd";
import { FormMultiSelect } from "../../FormInputs/FormSelect";
import { FormRadioGroup } from "../../FormInputs/FormRadio";
import { getApi, postApi } from "../../../utils/apiServices";
import {
  ADD_TOPIC_ADVERTISEMENT_ITEM,
  DELETE_TOPIC_ADVERTISEMENT_ITEM,
  GET_CATEGORIES_LIST,
  GET_PRODUCTS_VARIENTS_LIST_DROPDOWN,
  GET_TOPIC_ADVERTISEMENT_ITEMS,
  UPDATE_TOPIC_ADVERTISEMENT_ITEM,
} from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { MoreOutlined } from "@ant-design/icons";
import ToastHelper from "../../../services/ToastHelper";
import FormInput from "../../FormInputs/FormInput";
import UploadTopicMedia from "../../FormInputs/UploadTopicMedia";

const DEFAULT_CROP = { aspect: 1 / 1 };

const AddAdvertisementTopic = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const topicData = location.state.topicData;
  const [form] = Form.useForm();

  const [activeTab, setActiveTab] = useState("1");
  const [advertisementTopics, setAdvertisementTopics] = useState([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryOption, setCategoryOption] = useState(null);
  const [categoryList1, setCategoryList1] = useState([]);
  const [categoryList2, setCategoryList2] = useState([]);
  const [categoryList3, setCategoryList3] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [topicType, setTopicType] = useState(null);
  const [desktopbase64, setDesktopBase64] = useState(null);
  const [mobilebase64, setMobileBase64] = useState(null);
  const [editData, setEditData] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);

  const parseAspectRatio = (aspectRatio) => {
    if (!aspectRatio || !aspectRatio.includes(":")) return DEFAULT_CROP.aspect;
    const [width, height] = aspectRatio.split(":").map(Number);
    return width && height ? width / height : DEFAULT_CROP.aspect;
  };

  const defaultDesktopAspect = parseAspectRatio(topicData?.desktopAspectRatio);
  const defaultMobileAspect = parseAspectRatio(topicData?.mobileAspectRatio);

  const renderTab = (tab) => {
    return (
      <>
        <div className="advertisement-topic_cards">
          {advertisementTopics?.length > 0 &&
            advertisementTopics?.map((topic, index) => {
              return (
                <div key={index} className="advertisement-topic_card">
                  <div
                    className="advertisement-topic_card_image"
                    onClick={() => handleTopicItems(topic)}
                  >
                    <img
                      src={`${IMAGE_BASE_PATH}${topic?.desktopMediaUrl}`}
                      alt=""
                    />
                  </div>
                  <div className="advertisement-topic_card_content">
                    <h3>{topic?.name}</h3>
                    <Popover
                      overlayClassName="plugin-screenshot-popover"
                      content={
                        <div className="topics-list_card_right_sec_options">
                          <Button onClick={() => handleDeleteModal(topic)}>
                            Delete
                          </Button>
                          <Button onClick={() => handleEditTopicItem(topic)}>
                            Edit
                          </Button>
                        </div>
                      }
                      arrow={true}
                      trigger="click"
                      placement="topRight"
                      open={open === index + 1}
                      onOpenChange={(isOpen) => handleOpen(index + 1, isOpen)}
                    >
                      <MoreOutlined style={{ fontSize: "18px" }} />
                    </Popover>
                  </div>
                </div>
              );
            })}
        </div>
        {loading ? (
          <div className="advertisement-topic_loading">
            <Spin tip="Loading">{spinContent}</Spin>
          </div>
        ) : (
          advertisementTopics?.length === 0 && (
            <h5>No Advertisement topic available</h5>
          )
        )}
      </>
    );
  };

  const renderTab1 = (tab) => {
    return (
      <>
        <div className="advertisement-topic_cards">
          {advertisementTopics?.length > 0 &&
            advertisementTopics?.map((topic, index) => {
              return (
                <div key={index} className="advertisement-topic_card">
                  <div
                    className="advertisement-topic_card_image"
                    onClick={() => handleTopicItems(topic)}
                  >
                    <img
                      src={`${IMAGE_BASE_PATH}${topic?.mobileMediaUrl}`}
                      alt=""
                    />
                  </div>
                  <div className="advertisement-topic_card_content">
                    <h3>{topic?.name}</h3>
                    <Popover
                      overlayClassName="plugin-screenshot-popover"
                      content={
                        <div className="topics-list_card_right_sec_options">
                          <Button onClick={() => handleDeleteModal(topic)}>
                            Delete
                          </Button>
                          <Button onClick={() => handleEditTopicItem(topic)}>
                            Edit
                          </Button>
                        </div>
                      }
                      arrow={true}
                      trigger="click"
                      placement="topRight"
                      open={open1 === index + 1}
                      onOpenChange={(isOpen) => handleOpen1(index + 1, isOpen)}
                    >
                      <MoreOutlined style={{ fontSize: "18px" }} />
                    </Popover>
                  </div>
                </div>
              );
            })}
        </div>
        {loading ? (
          <div className="advertisement-topic_loading">
            <Spin tip="Loading">{spinContent}</Spin>
          </div>
        ) : (
          advertisementTopics?.length === 0 && (
            <h5>No Advertisement topic available</h5>
          )
        )}
      </>
    );
  };

  const onChange = (key) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: "1",
      label: "Desktop view",
      children: renderTab(1),
    },
    {
      key: "2",
      label: "Mobile view",
      children: renderTab1(2),
    },
  ];

  const handleOpen = (id, isOpen) => {
    if (isOpen) {
      setOpen(id);
    } else {
      setOpen(null);
    }
  };

  const handleOpen1 = (id, isOpen) => {
    if (isOpen) {
      setOpen1(id);
    } else {
      setOpen1(null);
    }
  };

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        title: editData?.name,
      });

      const mobileUrl = editData
        ? `${IMAGE_BASE_PATH}${editData?.mobileMediaUrl}`
        : mobilebase64;
      const desktopUrl = editData
        ? `${IMAGE_BASE_PATH}${editData?.desktopMediaUrl}`
        : desktopbase64;
      setMobileBase64(mobileUrl);
      setDesktopBase64(desktopUrl);
    }
  }, [editData]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      setIsLoading(true);

      let selectedIds = [];
      if (topicType === 3) {
        if (categoryOption === 1) {
          selectedIds = values.categoryLayer1 || [];
        } else if (categoryOption === 2) {
          selectedIds = values.categoryLayer2 || [];
        } else if (categoryOption === 3) {
          selectedIds = values.categoryLayer3 || [];
        }
      } else if (topicType === 2) {
        selectedIds = values.products || [];
      }

      const payload = {
        topicType: topicType,
        topicId: topicData?.topicId,
        name: values?.title,
        mobileMedia: mobilebase64?.split(",")[1],
        desktopMedia: desktopbase64?.split(",")[1],
        topicItems: topicType === 3 ? [selectedIds] : selectedIds,
        linkedId: 0,
        metaTitle: "",
        metaDescription: "",
        urlName: "",
      };
      const res = await postApi(`${ADD_TOPIC_ADVERTISEMENT_ITEM}`, payload);
      setIsLoading(false);
      message.success("Advertisement topic items added successfully");
      form.resetFields();
      setCategoryOption(null);
      setEditData(null);
      setTopicType(null);
      setDesktopBase64(null);
      setMobileBase64(null);
      setIsModalOpen(false);
      getTopicItems();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleUpdate = async () => {
    try {
      await form.validateFields({
        validateFields: (name) => name !== "topicType",
      });
      const values = form.getFieldsValue();
      setIsLoading(true);

      const payload = {
        name: values?.title,
        mobileMedia: mobilebase64?.split(",")[1],
        desktopMedia: desktopbase64?.split(",")[1],
        topicMediaId: editData?.topicMediaId,
        metaTitle: "",
        metaDescription: "",
        urlName: "",
      };
      const res = await postApi(`${UPDATE_TOPIC_ADVERTISEMENT_ITEM}`, payload);
      setIsLoading(false);
      message.success("Advertisement topic items updated successfully");
      form.resetFields();
      setCategoryOption(null);
      setEditData(null);
      setTopicType(null);
      setDesktopBase64(null);
      setMobileBase64(null);
      setIsModalOpen(false);
      getTopicItems();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleCancel = () => {
    setCategoryOption(null);
    setEditData(null);
    setTopicType(null);
    setDesktopBase64(null);
    setMobileBase64(null);
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleBack = () => {
    navigate("/manage-topics");
  };

  useEffect(() => {
    getTopicItems();
    getProductsList();
  }, []);

  const getTopicItems = async () => {
    setLoading(true);
    const payload = {
      topicId: topicData?.topicId,
    };
    try {
      const res = await postApi(`${GET_TOPIC_ADVERTISEMENT_ITEMS}`, payload);
      setAdvertisementTopics(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  const fetchCategories = async (parentId = 0) => {
    const payload = {
      pageIndex: 0,
      pageSize: 100,
      searchString: "",
      parentCategoryId: parentId,
    };
    try {
      const res = await postApi(`${GET_CATEGORIES_LIST}`, payload);
      return res?.data || [];
    } catch (error) {
      console.error("Error fetching categories", error);
      return [];
    }
  };

  const getProductsList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_PRODUCTS_VARIENTS_LIST_DROPDOWN}`);
      setProductsList(res?.map((item) => ({ label: `${item?.productName} (${item?.color})`, value: item?.productVariantId })));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    (async () => {
      const options = await fetchCategories();
      setCategoryList1(
        options.map((item) => ({ label: item.title, value: item.id }))
      );
    })();
  }, []);

  const handleLayer1Change = async (value) => {
    form.setFieldsValue({ categoryLayer2Id: null, categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList2(
      options.map((item) => ({ label: item.title, value: item.id }))
    );
    setCategoryList3([]);
  };

  const handleLayer2Change = async (value) => {
    form.setFieldsValue({ categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList3(
      options.map((item) => ({ label: item.title, value: item.id }))
    );
  };

  const handleValuesChange = (changedValues, allValues) => {
    if ("categoryOption" in changedValues) {
      setCategoryOption(changedValues?.categoryOption);
      form.setFieldsValue({
        categoryLayer1: null,
        categoryLayer2: null,
        categoryLayer3: null,
      });
    }
    if ("topicType" in changedValues) {
      setTopicType(changedValues?.topicType);
    }
  };

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(null);
    setOpen1(null);
    setOpen2(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen2(false);
  };

  const handleDeleteTopicItem = async () => {
    try {
      const payload = {
        itemId: deleteItem?.itemId,
        topicId: topicData?.topicId,
        topicType: topicData?.topicType,
        topicMediaId: deleteItem?.topicMediaId,
      };
      const res = await postApi(`${DELETE_TOPIC_ADVERTISEMENT_ITEM}`, payload);

      if (res?.statusCode === 200) {
        ToastHelper.success("Advertisement topic deleted successfully");
        handleClose();
        getTopicItems();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditTopicItem = (topic) => {
    setEditData(topic);
    showModal();
    setOpen(null);
    setOpen1(null);
  };

  const handleTopicItems = (topic) => {
    const data = {
      ...topicData,
      topicType: topic?.relationType?.relationTypeId,
      title: topic?.name,
      relatedIds: topic?.relatedIds,
      topicMediaId: topic?.topicMediaId,
      name: topicData?.title,
    };
    if (topic?.relationType?.relationTypeId === 3) {
      navigate(`/manage-topics/advertisement/${topicData?.topicId}/category`, {
        state: { topicData: data },
      });
    } else {
      navigate(`/manage-topics/advertisement/${topicData?.topicId}/product`, {
        state: { topicData: data },
      });
    }
  };

  const handleUploadDesktop = (croppedBlob) => {
    setDesktopBase64(croppedBlob);
  };

  const handleUploadMobile = (croppedBlob) => {
    setMobileBase64(croppedBlob);
  };

  return (
    <div className="advertisement-topic">
      <div className="advertisement-topic_container">
        <div className="advertisement-topic_header">
          <div className="advertisement-topic_header_left">
            <h2>Advertisement Topics</h2>
            <div className="advertisement-topic_header_left_links">
              <span onClick={handleBack}>Topics</span>
              <span className="active"> / {topicData?.title}</span>
            </div>
          </div>
          <div className="advertisement-topic_header_right">
            <Button type="primary" onClick={showModal}>
              Add
            </Button>
          </div>
        </div>
        <div className="advertisement-topic_sections">
          <div className="advertisement-topic_tabs">
            <Tabs activeKey={activeTab} items={items} onChange={onChange} />
          </div>
        </div>
      </div>
      <Modal
        title="Add advertisement topic"
        open={isModalOpen}
        onOk={editData ? handleUpdate : handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
        width={640}
      >
        <Spin spinning={isLoading}>
          <div className="advertisement-topic_modal">
            <Form
              form={form}
              layout="vertical"
              onValuesChange={handleValuesChange}
            >
              <div className="advertisement-topic_modal_uploads">
                <UploadTopicMedia
                  onUpload={handleUploadDesktop}
                  imageFile={desktopbase64}
                  defaultAspect={defaultDesktopAspect}
                  title="Desktop view advertisement"
                  showAlt={false}
                  setImageFile={setDesktopBase64}
                />
                <UploadTopicMedia
                  onUpload={handleUploadMobile}
                  imageFile={mobilebase64}
                  defaultAspect={defaultMobileAspect}
                  title="Mobile view advertisement"
                  showAlt={false}
                  setImageFile={setMobileBase64}
                />
              </div>
              <FormInput
                label="Advertisement Title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please enter advertisement title",
                  },
                ]}
                placeholder="Enter advertisement title"
              />
              <FormRadioGroup
                label="Select topic type"
                name="topicType"
                rules={
                  editData
                    ? []
                    : [
                        {
                          required: true,
                          message: "Please select an topic type",
                        },
                      ]
                }
                disabled={editData ? true : false}
                options={topicTypeOptions}
              />
              {topicType === 3 && (
                <>
                  <FormRadioGroup
                    label="Select the category option"
                    name="categoryOption"
                    rules={[
                      {
                        required: true,
                        message: "Please select an category option",
                      },
                    ]}
                    options={categoryOptions}
                  />
                  {categoryOption && (
                    <FormMultiSelect
                      label="Select category layer1"
                      name="categoryLayer1"
                      placeholder="Select category layer1"
                      rules={[{ required: true }]}
                      options={categoryList1}
                      // mode={categoryOption === 1 && "multiple"}
                      onChange={
                        categoryOption === 1 ? null : handleLayer1Change
                      }
                    />
                  )}
                  {(categoryOption === 2 || categoryOption === 3) && (
                    <FormMultiSelect
                      label="Select category layer2"
                      name="categoryLayer2"
                      placeholder="Select category layer2"
                      rules={[{ required: true }]}
                      options={categoryList2}
                      // mode={categoryOption === 2 && "multiple"}
                      onChange={
                        categoryOption !== 3 ? null : handleLayer2Change
                      }
                    />
                  )}
                  {categoryOption === 3 && (
                    <FormMultiSelect
                      label="Select category layer3"
                      name="categoryLayer3"
                      placeholder="Select category layer3"
                      rules={[{ required: true }]}
                      options={categoryList3}
                      // mode={categoryOption === 3 && "multiple"}
                    />
                  )}
                </>
              )}
              {topicType === 2 && (
                <FormMultiSelect
                  label="Select products"
                  name="products"
                  placeholder="Select products"
                  rules={[{ required: true }]}
                  options={productsList}
                  mode="multiple"
                />
              )}
            </Form>
          </div>
        </Spin>
      </Modal>
      <Modal
        title="Confirm"
        open={open2}
        onOk={handleDeleteTopicItem}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default AddAdvertisementTopic;
